import { render, staticRenderFns } from "./create-customer.vue?vue&type=template&id=3ef2b323&scoped=true"
import script from "./create-customer.vue?vue&type=script&lang=js"
export * from "./create-customer.vue?vue&type=script&lang=js"
import style0 from "./create-customer.vue?vue&type=style&index=0&id=3ef2b323&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef2b323",
  null
  
)

export default component.exports